(ns frontend.view.components.timeline.entry.phone-call-log
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.db :as db]
            [common.localization :as loc]
            [clojure.string :as string]
            [frontend.state.current-session :as session]))

(defn comment-text [text]
  (if (string/blank? text)
    (loc/tr :none)
    (->> text
         (take db/timeline-comment-length)
         (string/join ""))))

(defn who [{:keys [person/first-name person/last-name]}]
  (str first-name " " last-name))

(defn target-text [entity]
  (case (:entity/type entity)
    :entity.type/oppo (->> entity :oppo/name vector (loc/tr :phone-call-deal))
    :entity.type/company (->> entity :asset/name vector (loc/tr :phone-call-company))
    ""))

(defn title-generator [entry]
  (let [target (->> entry
                    :audit/target-changes
                    :phone-call/target
                    :set)
        target-text (target-text target)
        phone-call-text (->> entry
                             :audit/target
                             (get @session/entities)
                             :phone-call/text
                             comment-text
                             vector
                             (loc/tr :phone-call-text))
        person (->> entry
                    :audit/target-changes
                    :phone-call/person
                    :set
                    who
                    vector
                    (loc/tr :call-to))
        {:keys [change-text!]} entry]
    [:span
     (str target-text person phone-call-text)
     [:i.fal.fa-pencil.edit-icon
      {:on-click (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (change-text!))}]]))

(defmethod te/timeline-entry-view :op.phone-call/log [{entry :entry}]
  [default/timeline-item-view entry title-generator default/body-generator])
